import { ApplicantionFromToken } from '../../models/doc-upload.model';
import { ActionTypes } from './action-types';
import { ISetUserDetails } from './types';

export const updatePlaidUserInfo = (userInfo: any) => ({
  type: ActionTypes.UpdatePlaidUserInfo,
  payload: {
    userInfo,
  },
});

export const setEnableDocUpload = (enableDocUpload: boolean) => ({
  type: ActionTypes.SetEnableDocUpload,
  payload: {
    enableDocUpload,
  },
});

export const setUserDetails = (userDetails: ApplicantionFromToken | null): ISetUserDetails => ({
  type: ActionTypes.SetUserDetails,
  payload: {
    userDetails,
  },
});
